(function () {
  if (window.__RB_V2_LOADED__) return;
  window.__RB_V2_LOADED__ = true;

  // ----------------- CONFIG -----------------
  var RB = {
    storageKey: "RB_SESSION_V2",
    pages: {
      chooseDiamond: "/pages/choose-diamond",
      chooseSetting: "/pages/choose-setting",
      chooseGemstone: "/pages/choose-gemstone",
      complete: "/pages/complete-ring"
    },
    collections: {
      diamond: "build-a-diamond",
      setting: "build-a-ring",
      gemstone: "build-a-gemstone"
    },
    money: { currency: "MYR", locale: "en-MY" },
    pageSize: 24
  };

  // ----------------- UTIL -----------------
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getParam(name) {
    try { return new URL(window.location.href).searchParams.get(name); }
    catch (e) { return null; }
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function fmtMoneyCents(cents) {
    var amt = (Number(cents || 0) / 100);
    try {
      return new Intl.NumberFormat(RB.money.locale, { style: "currency", currency: RB.money.currency }).format(amt);
    } catch (e) {
      return "RM " + amt.toFixed(2);
    }
  }

  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(RB.storageKey) || "null"); }
    catch (e) { return null; }
  }

  function writeSession(s) {
    if (!Array.isArray(s.stones)) s.stones = s.diamond ? [s.diamond] : [];
    sessionStorage.setItem(RB.storageKey, JSON.stringify(s));
  }

  function stoneCount(setting) {
    var tags = (setting && setting.tags || []).map(function (t) { return String(t).toLowerCase(); });
    if (tags.includes("3-stone")) return 3;
    if (tags.includes("2-stone")) return 2;
    return Number(setting && setting.stone_count) || 1;
  }

  function chosenStones(s) {
    return (Array.isArray(s.stones) ? s.stones : (s.diamond ? [s.diamond] : [])).slice(0, stoneCount(s.setting));
  }

  function saveStone(s, stone) {
    var count = stoneCount(s.setting);
    var index = Math.max(0, Math.min(count - 1, Math.floor(Number(getParam("stone") || s.edit_stone || 0)) || 0));
    s.stones = chosenStones(s);
    s.stones[index] = stone;
    s.diamond = s.stones[0] || null;
    s.edit_stone = null;
    writeSession(s);
  }

  function nextBuilderPage(s) {
    var start = encodeURIComponent(s.started_with || s.start_mode || "diamond");
    if (!s.setting) return RB.pages.chooseSetting + "?start=" + start;
    var stones = chosenStones(s);
    for (var i = 0; i < stoneCount(s.setting); i++) {
      if (!stones[i] || !stones[i].handle) return RB.pages.chooseDiamond + "?start=" + start + "&stone=" + i;
    }
    return RB.pages.complete + "?start=" + start;
  }

  function stoneLabel(index, count) {
    return count === 3 ? ["Centre diamond", "Left diamond", "Right diamond"][index] : count === 2 ? "Diamond " + (index + 1) : "Stone";
  }

  function clearSession() {
    sessionStorage.removeItem(RB.storageKey);
  }

  try {
    localStorage.removeItem(RB.storageKey);
    localStorage.removeItem('RB_SESSION');
  } catch (_) {}

  function makePairId() {
    var d = new Date();
    function pad(n) { return String(n).padStart(2, "0"); }
    return [
      "PJ",
      d.getFullYear(),
      pad(d.getMonth() + 1),
      pad(d.getDate()),
      pad(d.getHours()),
      pad(d.getMinutes()),
      pad(d.getSeconds()),
      Math.random().toString(16).slice(2, 6).toUpperCase()
    ].join("-");
  }

  function ensureSession() {
    var s = readSession();
    if (!s) {
      s = {
        pair_id: makePairId(),
        started_at: Date.now(),
        started_with: null,
        start_mode: null,
        diamond: null,   // used for "stone" (diamond or gemstone)
        setting: null,
        stone_mode: "lab" // lab | mined (only affects diamond page filtering)
      };
      writeSession(s);
    } else {
      if (!s.pair_id) s.pair_id = makePairId();
      if (!s.started_at) s.started_at = Date.now();
      if (!("diamond" in s)) s.diamond = null;
      if (!("setting" in s)) s.setting = null;
      if (!("stone_mode" in s) || !s.stone_mode) s.stone_mode = "lab";

      if (!s.started_with && (s.start_mode === "diamond" || s.start_mode === "setting")) {
        s.started_with = s.start_mode;
      }
      if (!s.start_mode && (s.started_with === "diamond" || s.started_with === "setting")) {
        s.start_mode = s.started_with;
      }

      writeSession(s);
    }
    return s;
  }

  function setStartedWith(session, mode) {
    if (mode !== "diamond" && mode !== "setting") return;
    session.started_with = mode;
    session.start_mode = mode;
    writeSession(session);
  }

  function safeNum(n) {
    var x = Number(n);
    return isFinite(x) ? x : null;
  }

  // Try to read currently selected variant id from the product form (Metal now, Size later)
  function getSelectedVariantIdFromButton(startBtn) {
    var formId = startBtn.getAttribute("data-rb-product-form-id");
    var formEl = formId ? document.getElementById(formId) : null;

    if (!formEl) {
      var pf = startBtn.closest("product-form");
      if (pf) formEl = qs("form", pf);
    }
    if (!formEl) {
      formEl = startBtn.closest("form");
    }

    var idInput = formEl ? qs('input[name="id"]', formEl) : null;
    var vid = idInput ? idInput.value : null;

    // fallback (older markup)
    if (!vid) vid = startBtn.getAttribute("data-rb-variant-id");

    return vid ? String(vid) : null;
  }

  async function fetchProductByHandle(handle) {
    var url = "/products/" + encodeURIComponent(handle) + ".js";
    var res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load product: " + handle);
    return await res.json();
  }

  function priceCentsFromProductJsVariant(v) {
    var p = (v && v.price != null) ? v.price : 0;
    return Number(p) || 0;
  }

  function imgForProductJs(p) {
    if (p && p.featured_image) return p.featured_image;
    if (p && p.images && p.images[0]) return p.images[0];
    return "";
  }

  function imgForVariant(product, variant) {
    var metal = (variant && variant.options || []).join(' ').toLowerCase();
    var family = metal.includes('yellow gold') ? 'yellow-gold' : metal.includes('rose gold') ? 'rose-gold' : /white gold|platinum/.test(metal) ? 'white-gold' : null;
    var media = (product.media || []).filter(function (item) {
      return family && String(item.alt || '').toLowerCase().includes('[metal:' + family + ']');
    });
    var hero = media.find(function (item) { return /01[-_]front/i.test(item.src || (item.preview_image || {}).src || ''); }) || media[0];
    return (hero && (hero.src || (hero.preview_image || {}).src)) || (variant && variant.featured_image && variant.featured_image.src) || imgForProductJs(product);
  }

  function findVariantById(productJs, variantId) {
    if (!productJs || !productJs.variants || !variantId) return null;
    var vid = Number(variantId);
    return (productJs.variants || []).find(function (v) { return Number(v.id) === vid; }) || null;
  }

  function productTags(product) {
    if (!product || !product.tags) return [];
    if (Array.isArray(product.tags)) return product.tags.map(String);
    return String(product.tags).split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
  }

  function taggedValue(product, prefix) {
    var lowerPrefix = String(prefix).toLowerCase();
    var match = productTags(product).find(function (tag) { return tag.toLowerCase().indexOf(lowerPrefix) === 0; });
    return match ? match.slice(prefix.length).trim() : null;
  }

  function stoneSpecs(product) {
    var title = String(product && product.title || '');
    var shapes = ['Round', 'Oval', 'Emerald', 'Cushion', 'Princess', 'Pear', 'Marquise', 'Heart', 'Radiant', 'Asscher'];
    var shape = shapes.find(function (name) {
      return productTags(product).some(function (tag) { return tag.toLowerCase() === name.toLowerCase(); }) || new RegExp('\\b' + name + '\\b', 'i').test(title);
    }) || null;
    var carat = taggedValue(product, 'Carat ');
    if (!carat) {
      var caratMatch = title.match(/(\d+(?:\.\d+)?)\s*ct\b/i);
      carat = caratMatch ? caratMatch[1] : null;
    }
    var clarity = taggedValue(product, 'Clarity ');
    if (!clarity) {
      var clarityMatch = title.match(/\b(FL|IF|VVS1|VVS2|VS1|VS2|SI1|SI2)\b/i);
      clarity = clarityMatch ? clarityMatch[1].toUpperCase() : null;
    }
    var colour = taggedValue(product, 'Colour ') || taggedValue(product, 'Color ');
    if (!colour) {
      var fancyMatch = title.match(/\b(Pink|Blue|Green|Yellow)\b/i);
      var gradeMatch = title.match(/\bct\s+([D-M])\b/i);
      colour = fancyMatch ? fancyMatch[1] : (gradeMatch ? gradeMatch[1].toUpperCase() : null);
    }
    return { shape: shape, carat: carat, clarity: clarity, colour: colour };
  }

  function diamondDisplaySpecs(product) {
    var specs = stoneSpecs(product);
    return {
      carat: specs.carat || null,
      colour: specs.colour || null,
      clarity: specs.clarity || null,
      shape: specs.shape || null
    };
  }

  function diamondCatalogueTitle(product) {
    var text = String([
      product && product.title,
      product && (product.product_type || product.type),
      productTags(product).join(' ')
    ].filter(Boolean).join(' ')).toLowerCase();
    if (/\b(lab|laboratory)[ -]?grown\b|\blab diamond\b/.test(text)) return 'IGI Lab-Grown Diamond';
    if (/\b(natural|mined)\b/.test(text)) return 'Natural Diamond';
    return 'Diamond';
  }

  function sortDiamonds(products, sortKey) {
    if (!sortKey || sortKey === 'featured') return products.slice();
    var clarityOrder = ['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2','I1','I2','I3'];
    var colourOrder = ['D','E','F','G','H','I','J','K','L','M'];
    function rank(value, order) {
      var index = order.indexOf(String(value || '').toUpperCase());
      return index < 0 ? 999 : index;
    }
    function number(value) {
      var parsed = Number(value);
      return isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER;
    }
    return products.slice().sort(function (a, b) {
      var aSpecs = diamondDisplaySpecs(a), bSpecs = diamondDisplaySpecs(b), result = 0;
      if (sortKey === 'carat-asc') result = number(aSpecs.carat) - number(bSpecs.carat);
      if (sortKey === 'carat-desc') result = number(bSpecs.carat) - number(aSpecs.carat);
      if (sortKey === 'colour') result = rank(aSpecs.colour, colourOrder) - rank(bSpecs.colour, colourOrder);
      if (sortKey === 'clarity') result = rank(aSpecs.clarity, clarityOrder) - rank(bSpecs.clarity, clarityOrder);
      if (sortKey === 'price-asc') result = getFirstVariantMetaFromProductsJson(a).price_cents - getFirstVariantMetaFromProductsJson(b).price_cents;
      if (sortKey === 'price-desc') result = getFirstVariantMetaFromProductsJson(b).price_cents - getFirstVariantMetaFromProductsJson(a).price_cents;
      return result || String(a.title || '').localeCompare(String(b.title || ''));
    });
  }

  function variantOptions(product, variant) {
    var values = variant && Array.isArray(variant.options) ? variant.options : [];
    return (product && Array.isArray(product.options) ? product.options : []).reduce(function (result, option, index) {
      var name = typeof option === 'string' ? option : option && option.name;
      if (name && values[index]) result[name] = values[index];
      return result;
    }, {});
  }

  function metalFromOptions(options, variantTitle) {
    var key = Object.keys(options || {}).find(function (name) { return /metal/i.test(name); });
    return key ? options[key] : (variantTitle && variantTitle !== 'Default Title' ? variantTitle : null);
  }

  function getRingSizeInput(element) {
    var formId = element && element.getAttribute('data-rb-product-form-id');
    var form = formId ? document.getElementById(formId) : element && element.closest('form');
    var productInfo = element && element.closest('product-info');
    return (form && qs('[data-rb-ring-size]', form)) || (productInfo && qs('[data-rb-ring-size]', productInfo)) || null;
  }

  function validateRingSize(input) {
    if (!input) return true;
    var wrapper = input.closest('.pj-ring-size');
    var error = wrapper && qs('[data-rb-ring-size-error]', wrapper);
    var valid = !!input.value;
    if (wrapper) wrapper.classList.toggle('is-invalid', !valid);
    if (error) error.hidden = valid;
    input.setAttribute('aria-invalid', String(!valid));
    if (!valid) input.focus();
    return valid;
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-rb-ring-size]')) validateRingSize(event.target);
  });

  document.addEventListener('submit', function (event) {
    var input = qs('[data-rb-ring-size]', event.target);
    if (input && !validateRingSize(input)) event.preventDefault();
  }, true);

  // ----------------- DUPLICATE SUMMARY BLOCK (safety) -----------------
  // If theme still contains [data-rb-summary], we hard-clear it so it does not render elsewhere.
  function clearInlineSummaryIfExists() {
    var el = qs("[data-rb-summary]");
    if (el) el.innerHTML = "";
  }

  // ----------------- GLOBAL START BUTTON (PRODUCT PAGE) -----------------
  document.addEventListener("click", async function (e) {
    var startBtn = e.target.closest("[data-rb-start-product]");
    if (!startBtn) return;

    e.preventDefault();
    if (startBtn.disabled) return;

    // Step B patch: allow "gemstone" here too
    var kind = startBtn.getAttribute("data-rb-kind"); // "diamond" or "setting" or "gemstone"
    var handle = startBtn.getAttribute("data-rb-handle") || null;
    var title = startBtn.getAttribute("data-rb-title") || null;
    var url = startBtn.getAttribute("data-rb-url") || null;

    // IMPORTANT: read selected variant from the product form
    var variantId = getSelectedVariantIdFromButton(startBtn);
    var ringSizeInput = kind === 'setting' ? getRingSizeInput(startBtn) : null;
    if (ringSizeInput && !validateRingSize(ringSizeInput)) return;
    var selectedRingSize = ringSizeInput ? ringSizeInput.value : null;
    var picker = startBtn.closest('product-info')?.querySelector('variant-selects');
    if (picker) {
      picker.updateOptions();
      picker.updateMasterId();
      variantId = picker.currentVariant && picker.currentVariant.id;
    }
    if (!variantId) return;
    startBtn.disabled = true;
    startBtn.setAttribute('aria-busy', 'true');

    var s = ensureSession();

    // Preserve original start if already set, otherwise set it now
    if (!s.started_with && !s.start_mode) {
      // gemstone is a "stone", so started_with should be "diamond" not "setting"
      setStartedWith(s, (kind === "setting") ? "setting" : "diamond");
      s = ensureSession();
    }

    var startKey = encodeURIComponent(s.started_with || s.start_mode || "diamond");

    // Enrich with real price + image using product.js so step bar can show correct price
    var enriched = null;
    if (handle && variantId) {
      try {
        var pjs = await fetchProductByHandle(handle);
        var v = findVariantById(pjs, variantId);
        if (!v || !v.available) throw new Error('This option is unavailable. Please choose another option.');
        enriched = {
          stone_count: stoneCount(pjs),
          price_cents: v ? priceCentsFromProductJsVariant(v) : null,
          image: imgForVariant(pjs, v),
          variant_title: v.title,
          variant_options: variantOptions(pjs, v),
          stone_specs: stoneSpecs(pjs),
          title: title || (pjs && pjs.title ? pjs.title : null)
        };
      } catch (err) {
        startBtn.disabled = false;
        startBtn.removeAttribute('aria-busy');
        var error = startBtn.closest('product-form');
        if (error && error.handleErrorMessage) error.handleErrorMessage(err.message);
        return;
      }
    }

    // Step B patch: gemstone behaves exactly like diamond here
    if (kind === "diamond" || kind === "gemstone") {
      s.diamond = {
        handle: handle,
        title: (enriched && enriched.title) ? enriched.title : title,
        image: (enriched && enriched.image) ? enriched.image : null,
        product_url: url,
        variant_id: variantId ? Number(variantId) : null,
        variant_title: enriched ? enriched.variant_title : null,
        specs: enriched ? enriched.stone_specs : null,
        price_cents: (enriched && typeof enriched.price_cents === "number") ? enriched.price_cents : null,
        stone_kind: (kind === "gemstone") ? "gemstone" : "diamond"
      };
      saveStone(s, s.diamond);

      if (s.setting && s.setting.handle) {
        window.location.href = nextBuilderPage(s);
        return;
      }

      window.location.href = RB.pages.chooseSetting + "?start=" + startKey;
      return;
    }

    if (kind === "setting") {
      s.setting = {
        stone_count: enriched ? enriched.stone_count : 1,
        handle: handle,
        title: (enriched && enriched.title) ? enriched.title : title,
        image: (enriched && enriched.image) ? enriched.image : null,
        product_url: url,
        variant_id: variantId ? Number(variantId) : null,
        variant_title: enriched ? enriched.variant_title : null,
        variant_options: enriched ? enriched.variant_options : null,
        metal: enriched ? metalFromOptions(enriched.variant_options, enriched.variant_title) : null,
        ring_size: selectedRingSize,
        price_cents: (enriched && typeof enriched.price_cents === "number") ? enriched.price_cents : null
      };
      writeSession(s);

      s.stones = chosenStones(s);
      writeSession(s);
      window.location.href = nextBuilderPage(s);
      return;
    }
  });

  // ----------------- CART -----------------
  var inFlight = false;

  async function addLineItems(items) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    });

    if (!res.ok) {
      var txt = await res.text();
      throw new Error("Cart add failed: " + txt);
    }
    return res.json();
  }

  async function finalizeToCart(session, chosenStoneVariantId, chosenSettingVariantId, chosenSettingHandle) {
    if (inFlight) return;
    inFlight = true;

    var pairId = session.pair_id || makePairId();

    var stoneProps = {
      "_builder_pair_id": pairId,
      "Ring setting": session.setting.title || "Ring Setting",
      "Setting metal": session.setting.metal || session.setting.variant_title || "",
      "US Ring Size": session.setting.ring_size || ""
    };

    var settingProps = {
      "_builder_pair_id": pairId,
      "Selected stones": chosenStones(session).map(function (s) { return s.title; }).join("; "),
      "US Ring Size": session.setting.ring_size || ""
    };

    try {
      var ids = Array.isArray(chosenStoneVariantId) ? chosenStoneVariantId : [chosenStoneVariantId];
      var items = ids.map(function (id, index) {
        return { id: Number(id), quantity: 1, properties: Object.assign({}, stoneProps, { "Stone position": stoneLabel(index, ids.length) }) };
      });
      items.push({ id: Number(chosenSettingVariantId), quantity: 1, properties: settingProps });
      await addLineItems(items);
      clearSession();
      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      var status = qs('[data-rb-cart-status]');
      if (status) status.textContent = 'Could not add your ring. Your selections are saved; please try again.';
    } finally {
      inFlight = false;
    }
  }

  // ----------------- DATA FETCH -----------------
  async function fetchCollectionProducts(handle, page) {
    var url = "/collections/" + encodeURIComponent(handle) + "?view=rb-catalog&page=" + (page || 1);
    var res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load collection: " + handle);
    var json = await res.json();
    if (!json || !Array.isArray(json.products) || !Number.isInteger(json.pages)) throw new Error('Invalid catalogue response');
    return json;
  }

  // ----------------- PRICE HELPERS -----------------
  // products.json: variant.price is string like "3500.00"
  function priceCentsFromProductsJsonVariant(v) {
    var p = (v && v.price != null) ? String(v.price) : "0";
    var num = parseFloat(p || "0");
    if (!isFinite(num)) num = 0;
    return Math.round(num * 100);
  }

  function getFirstVariantMetaFromProductsJson(p) {
    var v = (p.variants || []).find(function (variant) { return variant.available; }) || (p.variants || [])[0] || null;
    return {
      variant_id: v ? v.id : null,
      available: !!(v && v.available),
      price_cents: v ? priceCentsFromProductsJsonVariant(v) : 0
    };
  }

  // ----------------- STEP BAR -----------------
  function rbOrder(session) {
    var started = (session && (session.started_with || session.start_mode)) || "diamond";
    if (started === "setting") return ["choose-setting", "choose-diamond", "complete"];
    return ["choose-diamond", "choose-setting", "complete"];
  }

  function rbLabels() {
    return {
      "choose-diamond": { title: "Choose a", label: "Stone", icon: "diamond" },
      "choose-setting": { title: "Choose a", label: "Setting", icon: "ring" },
      "complete": { title: "Complete", label: "Ring", icon: "review" }
    };
  }

  // Return { title, price_cents } for a given step key
  function rbChosenMeta(key, session) {
    if (!session) return null;

    if (key === "choose-diamond" && chosenStones(session).some(Boolean)) {
      var selected = chosenStones(session).filter(Boolean);
      return {
        items: selected.map(function (stone, index) {
          var specs = stone.specs || stoneSpecs({ title: stone.title, tags: [] });
          var details = [];
          if (specs.carat) details.push(specs.carat + ' ct');
          if (specs.clarity) details.push(specs.clarity + ' clarity');
          if (specs.shape) details.push(specs.shape + ' shape');
          return {
            title: selected.length > 1 ? stoneLabel(index, stoneCount(session.setting)) + ': ' + stone.title : stone.title,
            details: details
          };
        }),
        price_cents: selected.reduce(function (sum, stone) { return sum + Number(stone && stone.price_cents || 0); }, 0)
      };
    }

    if (key === "choose-setting" && session.setting && session.setting.title) {
      var settingDetails = [];
      if (session.setting.metal || session.setting.variant_title) settingDetails.push(session.setting.metal || session.setting.variant_title);
      if (session.setting.ring_size) settingDetails.push('US size ' + session.setting.ring_size);
      return {
        title: session.setting.title,
        details: settingDetails,
        price_cents: (typeof session.setting.price_cents === "number") ? session.setting.price_cents : null
      };
    }

    return null;
  }

  function renderSteps(stepsRoot, session, pageKey) {
    if (!stepsRoot) return;

    var order = rbOrder(session);
    var labels = rbLabels();
    var activeIdx = order.indexOf(pageKey);
    var selectedCount = chosenStones(session).filter(function (stone) { return stone && stone.handle && stone.variant_id; }).length;
    var requiredCount = stoneCount(session.setting);
    var text = Object.assign({ selected: 'Selected', pending: 'Not selected', partial: '[count] of [total] stones selected', review: 'Review your ring', editing: 'Editing', current: 'Current step' }, stepsRoot.dataset);

    var iconMap = {
      review: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" stroke="currentColor" stroke-width="1.4"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.4"/></svg>',
      diamond: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 9l4-5h10l4 5-9 11L3 9Z" stroke="currentColor" stroke-width="1.2"/><path d="M7 4l5 16M17 4l-5 16M3 9h18" stroke="currentColor" stroke-width="1.2"/></svg>',
      ring: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l3 4-3 4-3-4 3-4Z" stroke="currentColor" stroke-width="1.2"/><path d="M6.5 12.5c1.8-1.8 4-2.7 5.5-2.7s3.7.9 5.5 2.7c1.7 1.7 2.5 3.8 2.5 5 0 2.2-3.6 3.5-8 3.5s-8-1.3-8-3.5c0-1.2.8-3.3 2.5-5Z" stroke="currentColor" stroke-width="1.2"/></svg>',
      check: '<svg class="rb-ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    stepsRoot.innerHTML = order.map(function (key, idx) {
      var meta = labels[key];
      var isDone = key === "choose-setting" ? !!(session.setting && session.setting.handle && session.setting.variant_id) :
        key === "choose-diamond" && selectedCount === requiredCount;
      var isActive = idx === activeIdx;
      var chosen = rbChosenMeta(key, session);
      var status = isDone ? text.selected : text.pending;
      if (key === "choose-diamond" && selectedCount && !isDone) status = text.partial.replace('[count]', selectedCount).replace('[total]', requiredCount);
      if (key === "complete") status = text.review;
      if (isActive) status += ' · ' + (isDone ? text.editing : text.current);

      var cls = "rb__step";
      if (isActive) cls += " is-active";
      if (isDone) cls += " is-done";

      var chosenHtml = "";
      if (chosen && (chosen.title || chosen.items)) {
        var itemHtml = chosen.items ? chosen.items.map(function (item) {
          return '<div class="rb__step-choice-item"><strong>' + esc(item.title) + '</strong>' +
            (item.details && item.details.length ? '<span>' + esc(item.details.join(' · ')) + '</span>' : '') + '</div>';
        }).join('') : '<div class="rb__step-choice-item"><strong>' + esc(chosen.title) + '</strong>' +
          (chosen.details && chosen.details.length ? '<span>' + esc(chosen.details.join(' · ')) + '</span>' : '') + '</div>';
        chosenHtml =
          '<div class="rb__step-choice">' +
            itemHtml +
            (typeof chosen.price_cents === "number"
              ? '<div class="rb__step-price">' + esc(fmtMoneyCents(chosen.price_cents)) + "</div>"
              : "") +
          "</div>";
      }

      var startKey = encodeURIComponent(session.started_with || session.start_mode || "diamond");
      var stonePage = session.diamond && session.diamond.stone_kind === "gemstone" ? RB.pages.chooseGemstone : RB.pages.chooseDiamond;
      var destination = key === "choose-diamond" ? stonePage : key === "choose-setting" ? RB.pages.chooseSetting : null;
      var tag = destination ? "a" : "div";
      var attributes = destination ? ' href="' + destination + '?start=' + startKey + '"' : "";
      if (isActive) attributes += ' aria-current="step"';
      return (
        '<' + tag + ' class="' + cls + '"' + attributes + '>' +
          '<div class="rb__step-num" aria-hidden="true">' + (isDone ? iconMap.check : idx + 1) + "</div>" +
          '<div class="rb__step-icon">' + (iconMap[meta.icon] || "") + "</div>" +
          "<div>" +
            '<div class="rb__step-title">' + esc(meta.title) + "</div>" +
            '<div class="rb__step-label">' + esc(meta.label) + "</div>" +
            '<div class="rb__step-status">' + esc(status) + '</div>' +
            chosenHtml +
          "</div>" +
        "</" + tag + ">"
      );
    }).join("");
  }

  // ----------------- FILTER MODEL (MVP) -----------------
  function buildDefaultFilters(kind, stoneMode) {
    if (kind === "diamond") {
      // Lab vs mined is controlled by tabs (stone_mode) now, not by chips
      var diamondFilters = [
        { key: "shape", label: "Shape", type: "chips", iconOnly: true, values: ["Round", "Oval", "Emerald", "Cushion", "Princess", "Pear", "Marquise", "Heart", "Radiant", "Asscher"] },
        { key: "color", label: "Colour grade", type: "chips", values: ["D", "E", "F", "G", "H", "I", "J", "K"] },
        { key: "fancy_color", label: "Fancy colour", type: "chips", colourIcons: true, values: ["Pink", "Blue", "Green", "Yellow"] },
        { key: "clarity", label: "Clarity", type: "chips", values: ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2"] },
        { key: "carat", label: "Carat weight (ct)", type: "range" },
        { key: "price", label: "Price (RM)", type: "range" }
      ];
      if (stoneMode === "mined") {
        diamondFilters.splice(4, 0,
          { key: "cut", label: "Cut", type: "chips", values: ["Ideal", "Excellent", "Very Good", "Good", "Fair", "None"] },
          { key: "polish", label: "Polish", type: "chips", values: ["Excellent", "Very Good", "Good", "Fair"] },
          { key: "symmetry", label: "Symmetry", type: "chips", values: ["Excellent", "Very Good", "Good", "Fair"] },
          { key: "fluorescence", label: "Fluorescence", type: "chips", values: ["None", "Faint", "Medium", "Strong", "Very Strong"] }
        );
      }
      return diamondFilters;
    }

    if (kind === "gemstone") {
      return [
        { key: "type", label: "Gemstone", type: "chips", values: ["Sapphire", "Ruby", "Emerald", "Moissanite", "Spinel"] },
        { key: "color", label: "Color", type: "chips", values: ["Blue", "Pink", "Green", "Yellow", "White", "Red", "Purple"] },
        { key: "price", label: "Price (RM)", type: "range" }
      ];
    }

    // setting
    return [
      { key: "style", label: "Ring style", type: "chips", iconOnly: false, values: ["Solitaire", "Halo", "Pavé", "2-Stone", "3-Stone", "Twist", "Channel Set"] },
      { key: "price", label: "Price (RM)", type: "range" }
    ];
  }

  function normalizeFilterText(value) {
    return String(value == null ? "" : value)
      .replace(/&amp;/gi, "&")
      .replace(/[\u2010-\u2015_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function productFilterText(p) {
    var tags = Array.isArray(p && p.tags) ? p.tags : (p && p.tags ? [p.tags] : []);
    var options = (p && p.options || []).map(function (o) {
      return typeof o === "string" ? o : (o && (o.name || o.values || ""));
    });
    return normalizeFilterText(tags.concat([p && p.title, p && p.body_html], options).join(" "));
  }

  function filterTermMatches(text, term) {
    var normalized = normalizeFilterText(term);
    if (!normalized) return false;
    var escaped = normalized.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return new RegExp("(^|[^a-z0-9])" + escaped.replace(/\s+/g, "\\s+") + "([^a-z0-9]|$)", "i").test(text);
  }

  function filterValueAliases(key, value) {
    var n = normalizeFilterText(value);
    var aliases = {
      shape: { round: ["round", "brilliant"], oval: ["oval"], emerald: ["emerald"], cushion: ["cushion"], princess: ["princess", "square"], pear: ["pear", "teardrop"], marquise: ["marquise"], heart: ["heart"] },
      style: { "2-stone": ["2 stone", "two stone", "toi et moi"], "3-stone": ["3 stone", "three stone"], "channel set": ["channel set", "channel"], "pavé": ["pavé", "pave"], solitaire: ["solitaire"], halo: ["halo"], twist: ["twist"] },
      color: {}, fancy_color: {}, clarity: {}, cut: {}, polish: {}, symmetry: {}, fluorescence: {}, type: {},
      gemstone: {}
    };
    return [n].concat((aliases[key] && aliases[key][n]) || []);
  }

  function productMatchesFilterValue(p, key, value) {
    if (/diamond|gemstone/i.test(p.product_type || p.type || '')) {
      var facets = stoneFilterValues(p);
      if (Object.prototype.hasOwnProperty.call(facets, key)) return facets[key].some(function (v) { return normalizeFilterText(v) === normalizeFilterText(value); });
    }
    var text = productFilterText(p);
    return filterValueAliases(key, value).some(function (alias) {
      return filterTermMatches(text, alias);
    });
  }

  function productHasAnyTag(p, tags) {
    if (!tags || !tags.length) return true;
    var text = productFilterText(p);
    for (var i = 0; i < tags.length; i++) {
      if (productMatchesFilterValue(p, "style", tags[i]) || filterTermMatches(text, tags[i])) return true;
    }
    return false;
  }

  // Apply lab/mined gating for diamond page via tags
  function productMatchesStoneMode(p, stoneMode) {
    // Tag your products:
    // Lab diamonds: "Lab" or "Lab Grown" or "Lab-Grown"
    // Mined diamonds: "Natural" or "Mined" or "Mined Diamond"
    var text = normalizeFilterText(productTags(p).concat([p.title, p.product_type || p.type]).join(' '));

    if (stoneMode === "lab") {
      return ["lab", "lab grown", "lab-grown", "laboratory grown"].some(function (term) { return filterTermMatches(text, term); });
    }
    if (stoneMode === "mined") {
      return ["natural", "mined", "mined diamond"].some(function (term) { return filterTermMatches(text, term); });
    }
    return true;
  }

  function extractCaratWeight(p) {
    var taggedCarat = Number(stoneSpecs(p).carat);
    if (taggedCarat > 0) return taggedCarat;
    var text = productFilterText(p);
    var match = text.match(/(?:^|[^0-9])([0-9]+(?:\.[0-9]+)?)\s*(?:ct|carat|carats)(?:[^a-z0-9]|$)/i);
    return match ? Number(match[1]) : null;
  }

  var stoneFacetCache = new WeakMap();
  function stoneFilterValues(p) {
    if (stoneFacetCache.has(p)) return stoneFacetCache.get(p);
    var tags = productTags(p), specs = stoneSpecs(p), title = String(p.title || '');
    function prefixed(prefix) {
      var pattern = new RegExp('^(?:' + prefix + ')[\\s:_-]+(.+)$', 'i');
      return tags.map(function (tag) { var m = String(tag).match(pattern); return m ? m[1].trim() : ''; }).filter(Boolean);
    }
    function known(values) { return values.filter(function (v) { return tags.some(function (tag) { return normalizeFilterText(tag) === normalizeFilterText(v); }) || filterTermMatches(normalizeFilterText(title), v); }); }
    var colour = prefixed('colou?r');
    if (!colour.length) colour = known(['D','E','F','G','H','I','J','K','L','M']);
    var fancy = prefixed('fancy(?: colou?r)?').concat(colour.filter(function (v) { return !/^[D-Z]$/i.test(v); }));
    var result = {
      shape: prefixed('shape').concat(specs.shape || []),
      clarity: prefixed('clarity').concat(specs.clarity || []),
      color: colour,
      fancy_color: fancy,
      cut: prefixed('cut(?: grade)?'), polish: prefixed('polish'), symmetry: prefixed('symmetry'), fluorescence: prefixed('fluorescence'),
      type: prefixed('gemstone(?: type)?').concat(known(['Sapphire','Ruby','Emerald','Moissanite','Spinel']))
    };
    stoneFacetCache.set(p, result);
    return result;
  }

  function availableFilters(products, kind, mode) {
    var pool = products.filter(function (p) { return getFirstVariantMetaFromProductsJson(p).available && (kind !== 'diamond' || productMatchesStoneMode(p, mode)); });
    return buildDefaultFilters(kind, mode).map(function (definition) {
      if (definition.type !== 'chips') return definition;
      var candidates = definition.values.slice();
      if (kind !== 'setting') pool.forEach(function (p) {
        (stoneFilterValues(p)[definition.key] || []).forEach(function (value) {
          if (kind === 'diamond' && definition.key === 'color' && !/^[D-Z]$/i.test(value)) return;
          if (!candidates.some(function (existing) { return normalizeFilterText(existing) === normalizeFilterText(value); })) candidates.push(value);
        });
      });
      return Object.assign({}, definition, {values:candidates.filter(function (v) { return pool.some(function (p) { return productMatchesFilterValue(p, definition.key, v); }); })});
    }).filter(function (definition) { return definition.type !== 'chips' || definition.values.length; });
  }

  function filterIcon(key, value) {
    var n = normalizeFilterText(value);
    if (key === "fancy_color") {
      var fancyColours = {
        pink: "#e9a7bb",
        blue: "#75aee3",
        green: "#75bc9a",
        yellow: "#edc95b"
      };
      var swatch = fancyColours[n] || "#c9d4d4";
      return '<span class="rb__chip-icon rb__chip-icon--colour" aria-hidden="true" style="--rb-fancy-colour:' + swatch + '"><svg viewBox="0 0 64 64" focusable="false"><path class="rb__fancy-gem" d="M10 24 21 10h22l11 14-22 31L10 24Z"/><path class="rb__fancy-facets" d="M10 24h44M21 10l11 45M43 10 32 55M21 10l11 14 11-14M10 24l22 31 22-31"/></svg></span>';
    }
    var round = '<circle cx="32" cy="32" r="23"/><path d="M23 11h18l12 12v18L41 53H23L11 41V23zM25 20h14l5 12-5 12H25l-5-12zM23 11l2 9m16-9-2 9m14 3-9 9m9 9-14 3m2 9-2-9m-16 9 2-9m-14-3 9-9m-9-9 14-3"/>';
    var shapes = {
      round: round,
      oval: '<g transform="translate(9 0) scale(.72 1)">' + round + '</g>',
      emerald: '<path d="M23 7h18l10 10v30L41 57H23L13 47V17zM25 12h14l7 7v26l-7 7H25l-7-7V19zM26 18h12l3 4v20l-3 4H26l-3-4V22zM23 7l3 11m15-11-3 11M13 17l10 5m28-5-10 5M13 47l10-5m28 5-10-5M23 57l3-11m15 11-3-11"/>',
      cushion: '<path d="M16 11Q32 5 48 11Q59 32 48 53Q32 59 16 53Q5 32 16 11zM24 17h16l8 15-8 15H24l-8-15zM16 11l8 6m24-6-8 6M10 32h6m32 0h6M16 53l8-6m24 6-8-6M32 8v9m0 30v9"/>',
      princess: '<path d="M10 10h44v44H10zM16 16h32v32H16zM24 24h16v16H24zM10 10l14 14m30-14L40 24M10 54l14-14m30 14L40 40M32 10l-8 14m8-14 8 14M54 32l-14-8m14 8-14 8M32 54l-8-14m8 14 8-14M10 32l14-8m-14 8 14 8"/>',
      pear: '<path d="M32 6C28 17 13 27 13 39a19 19 0 0 0 38 0C51 27 36 17 32 6zM32 18l-11 19 4 12h14l4-12zM32 6v12M13 39l8-2m30 2-8-2M20 53l5-4m19 4-5-4M32 58v-9M21 37h22"/>',
      marquise: '<path d="M32 5Q65 32 32 59Q-1 32 32 5zM32 16l11 16-11 16-11-16zM32 5v11m0 32v11M16 32h5m22 0h5M21 17l11-1 11 1M21 47l11 1 11-1"/>',
      heart: '<path d="M32 56C24 48 9 38 9 23C9 8 25 6 32 17C39 6 55 8 55 23C55 38 40 48 32 56zM32 25l-11-5-4 12 15 15 15-15-4-12zM32 17v8M9 23l12-3m34 3-12-3M15 39l2-7m32 7-2-7M32 47v9M21 20l11 27 11-27"/>'
    };
    shapes.radiant = '<path d="M21 7h22l10 10v30L43 57H21L11 47V17zM24 18h16l5 14-5 14H24l-5-14zM21 7l3 11m19-11-3 11M11 17l34 15M53 17 19 32M11 47l34-15M53 47 19 32M21 57l3-11m19 11-3-11M32 7v11m0 28v11"/>';
    shapes.asscher = '<path d="M21 9h22l12 12v22L43 55H21L9 43V21zM24 16h16l8 8v16l-8 8H24l-8-8V24zM27 23h10l4 4v10l-4 4H27l-4-4V27zM21 9l6 14m16-14-6 14M9 21l14 6m32-6-14 6M9 43l14-6m32 6-14-6M21 55l6-14m16 14-6-14"/>';
    var artwork;
    if (key === "shape") artwork = shapes[n] || round;
    else if (key === "style") {
      var stone = '<g transform="translate(16 16) scale(.5)">' + round + '</g>';
      var band = '<path d="M21 27H8a5 5 0 0 0 0 10h13m22-10h13a5 5 0 0 1 0 10H43"/>';
      var beads = '';
      [9, 15, 49, 55].forEach(function (x) { beads += '<circle cx="' + x + '" cy="32" r="2.2"/>'; });
      var halo = '';
      for (var i = 0; i < 16; i++) {
        var a = i * Math.PI / 8;
        halo += '<circle cx="' + (32 + 16 * Math.cos(a)).toFixed(2) + '" cy="' + (32 + 16 * Math.sin(a)).toFixed(2) + '" r="2.1"/>';
      }
      var styles = {
        solitaire: band + stone,
        halo: band + halo + stone,
        'pavé': band + beads + stone,
        '2-stone': '<path d="M20 27H8a5 5 0 0 0 0 10h12m24-10h12a5 5 0 0 1 0 10H44"/><g transform="translate(8 11) scale(.45)">' + round + '</g><g transform="translate(27 24) scale(.36)">' + shapes.emerald + '</g>',
        '3-stone': band + '<g transform="translate(5 24) scale(.25)">' + round + '</g><g transform="translate(43 24) scale(.25)">' + round + '</g>' + stone,
        twist: '<path d="M3 28C14 17 21 41 32 37S49 20 61 28M3 36C14 47 21 23 32 27S49 44 61 36M3 28v8m58-8v8"/>' + stone,
        'channel set': band + '<path d="M7 28h14M7 36h14m22-8h14m-14 8h14M8 29h5v6H8zm7 0h5v6h-5zm29 0h5v6h-5zm7 0h5v6h-5z"/>' + stone
      };
      artwork = styles[n] || styles.solitaire;
    } else return "";
    return '<span class="rb__chip-icon" aria-hidden="true"><svg viewBox="0 0 64 64" focusable="false">' + artwork + '</svg></span>';
  }

  function applyFilters(products, state, kind) {
    var out = products.slice();

    // Chips filters are tag based
    Object.keys(state.chips).forEach(function (k) {
      var set = state.chips[k];
      if (!set || set.size === 0) return;

      var wanted = Array.from(set);
      out = out.filter(function (p) {
        return wanted.some(function (value) { return productMatchesFilterValue(p, k, value); });
      });
    });

    // Diamond tab gating (lab vs mined)
    if (kind === "diamond") {
      out = out.filter(function (p) {
        return productMatchesStoneMode(p, state.stoneMode || "lab");
      });
    }

    // Price range
    if (state.priceMinCents != null || state.priceMaxCents != null) {
      out = out.filter(function (p) {
        var meta = getFirstVariantMetaFromProductsJson(p);
        var cents = meta.price_cents;
        if (state.priceMinCents != null && cents < state.priceMinCents) return false;
        if (state.priceMaxCents != null && cents > state.priceMaxCents) return false;
        return true;
      });
    }

    if (kind === "diamond" && (state.caratMin != null || state.caratMax != null)) {
      out = out.filter(function (p) {
        var carat = extractCaratWeight(p);
        if (carat == null) return false;
        if (state.caratMin != null && carat < state.caratMin) return false;
        if (state.caratMax != null && carat > state.caratMax) return false;
        return true;
      });
    }

    return out;
  }

  // ----------------- CHOOSE PAGE -----------------
  async function initChoosePage(rbRoot) {
    clearInlineSummaryIfExists();

    var kind = rbRoot.getAttribute("data-rb-kind"); // diamond | setting | gemstone
    var collection = rbRoot.getAttribute("data-rb-collection");

    var start = getParam("start"); // "diamond" or "setting"
    var session = ensureSession();

    if (start === "diamond" || start === "setting") {
      setStartedWith(session, start);
      session = ensureSession();
    } else if (!session.started_with && !session.start_mode) {
      setStartedWith(session, "diamond");
      session = ensureSession();
    }

    // Step key mapping:
    // setting page: choose-setting
    // diamond or gemstone page: choose-diamond (stone step)
    var pageKey = (kind === "setting") ? "choose-setting" : "choose-diamond";

    var stepsRoot = qs("[data-rb-steps]", rbRoot);
    renderSteps(stepsRoot, session, pageKey);

    var filtersRoot = qs("[data-rb-filters]", rbRoot);
    if (kind !== "setting") {
      var requestedSlot = Math.max(0, Math.min(stoneCount(session.setting) - 1, Math.floor(Number(getParam("stone") || 0)) || 0));
      session.edit_stone = requestedSlot;
      writeSession(session);
      var slotPanel = document.createElement("div");
      slotPanel.className = "rb__selected";
      slotPanel.setAttribute("data-rb-stone-slots", "");
      var slotStart = encodeURIComponent(session.started_with || "diamond");
      slotPanel.innerHTML = '<div><strong>Choose ' + esc(stoneLabel(requestedSlot, stoneCount(session.setting)).toLowerCase()) + '</strong><p>Select each stone separately. The final total includes every selected stone.</p></div>' +
        Array.from({ length: stoneCount(session.setting) }, function (_, index) {
          var saved = chosenStones(session)[index];
          return '<a class="rb__btn rb__btn--ghost" ' + (index === requestedSlot ? 'aria-current="step" ' : '') + 'href="' + RB.pages.chooseDiamond + '?start=' + slotStart + '&stone=' + index + '">' + esc(stoneLabel(index, stoneCount(session.setting))) + ': ' + esc(saved ? saved.title : 'Choose') + '</a>';
        }).join("");
      if (stoneCount(session.setting) > 1) stepsRoot.insertAdjacentElement("afterend", slotPanel);
    }
    var gridRoot = qs("[data-rb-grid]", rbRoot);
    var countRoot = qs("[data-rb-count]", rbRoot);
    var clearBtn = qs("[data-rb-clear]", rbRoot);
    var loadMoreBtn = qs("[data-rb-loadmore]", rbRoot);
    var pageSizeRoot = document.createElement('div');
    pageSizeRoot.className = 'rb__page-size';
    pageSizeRoot.hidden = true;
    pageSizeRoot.setAttribute('role', 'group');
    pageSizeRoot.setAttribute('aria-label', stepsRoot.dataset.perPage);
    pageSizeRoot.innerHTML = '<span>' + esc(stepsRoot.dataset.perPage) + '</span>' + [24, 48].map(function (size) {
      return '<button type="button" data-rb-page-size="' + size + '" aria-pressed="' + (size === 24) + '">' + size + '</button>';
    }).join('');
    if (countRoot) countRoot.insertAdjacentElement('afterend', pageSizeRoot);
    var diamondTools = document.createElement('div');
    diamondTools.className = 'rb__diamond-tools';
    diamondTools.hidden = kind !== 'diamond';
    diamondTools.innerHTML = '<label class="rb__diamond-sort"><span>' + esc(stepsRoot.dataset.sort) + '</span><select data-rb-sort>' +
      [['featured',stepsRoot.dataset.sortFeatured],['carat-asc',stepsRoot.dataset.sortCaratAsc],['carat-desc',stepsRoot.dataset.sortCaratDesc],['colour',stepsRoot.dataset.sortColour],['clarity',stepsRoot.dataset.sortClarity],['price-asc',stepsRoot.dataset.sortPriceAsc],['price-desc',stepsRoot.dataset.sortPriceDesc]].map(function (option) {
        return '<option value="' + esc(option[0]) + '">' + esc(option[1]) + '</option>';
      }).join('') + '</select></label>' +
      '<div class="rb__view-switch" role="group" aria-label="' + esc(stepsRoot.dataset.view) + '">' +
        '<button type="button" data-rb-view="grid" aria-pressed="true"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg><span>' + esc(stepsRoot.dataset.gridView) + '</span></button>' +
        '<button type="button" data-rb-view="table" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16M8 4v16"/></svg><span>' + esc(stepsRoot.dataset.tableView) + '</span></button>' +
      '</div><p class="rb__representative-note">' + esc(stepsRoot.dataset.representative) + '</p>';
    var resultsMetaRoot = countRoot && countRoot.closest('.rb__results-meta');
    if (resultsMetaRoot) resultsMetaRoot.insertAdjacentElement('afterend', diamondTools);
    var paginationRoot = document.createElement('nav');
    paginationRoot.className = 'rb__pagination';
    paginationRoot.setAttribute('aria-label', stepsRoot.dataset.pagination);
    paginationRoot.hidden = true;
    if (gridRoot) gridRoot.insertAdjacentElement('afterend', paginationRoot);

    // Tabs (only relevant on diamond page)
    var stoneTabs = qs("[data-rb-stone-tabs]", rbRoot);

    var state = {
      chips: {},
      priceMinCents: null,
      priceMaxCents: null,
      caratMin: null,
      caratMax: null,
      currentPage: 1,
      perPage: RB.pageSize,
      sort: 'featured',
      view: 'grid',
      ready: false,
      loading: false,
      loaded: [],
      filtered: [],
      loadVersion: 0,
      stoneMode: (session && session.stone_mode) ? session.stone_mode : "lab"
    };

    function ensureChipSet(key) {
      if (!state.chips[key]) state.chips[key] = new Set();
      return state.chips[key];
    }

    function setStoneMode(mode) {
      state.stoneMode = mode;
      if (mode === "lab") {
        ["cut", "polish", "symmetry", "fluorescence"].forEach(function (key) {
          ensureChipSet(key).clear();
        });
      }
      var s = ensureSession();
      s.stone_mode = mode;
      writeSession(s);
    }

    // IMPORTANT:
    // Your Liquid might use data-stone OR data-stone-type.
    // This supports both so you never get stuck again.
    function readStoneModeFromBtn(btn) {
      return btn.getAttribute("data-stone") || btn.getAttribute("data-stone-type");
    }

    function syncTabActiveUI() {
      if (!stoneTabs) return;
      var buttons = qsa("[data-stone],[data-stone-type]", stoneTabs);
      buttons.forEach(function (b) {
        var mode = readStoneModeFromBtn(b);
        var active = kind === 'gemstone' ? mode === 'gemstone' : mode === (state.stoneMode || 'lab');
        b.classList.toggle("is-active", active);
        if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', String(active));
      });
    }

    function renderFilters() {
      var defs = availableFilters(state.loaded, kind, state.stoneMode);
      if (!filtersRoot) return;

      filtersRoot.innerHTML = defs.map(function (f) {
        if (f.type === "chips") {
          var chipsClass = f.iconOnly ? " rb__chips rb__chips--icons" : " rb__chips";
          if (f.colourIcons) chipsClass += " rb__chips--fancy-colours";
          return (
            '<div class="rb__filter" data-rb-filter="' + esc(f.key) + '">' +
              "<h3>" + esc(f.label) + "</h3>" +
              '<div class="' + chipsClass.trim() + '">' +
                f.values.map(function (v) {
                  var icon = filterIcon(f.key, v);
                  var iconClass = f.iconOnly ? " rb__chip--icon" : (f.colourIcons ? " rb__chip--fancy-colour" : "");
                  var labelClass = f.iconOnly ? " rb__chip-label rb__chip-label--sr" : "rb__chip-label";
                  return '<button type="button" class="rb__chip' + iconClass + '" data-rb-chip data-key="' + esc(f.key) + '" data-val="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '" aria-pressed="false">' + icon + '<span class="' + labelClass + '">' + esc(v) + "</span></button>";
                }).join("") +
              "</div>" +
            "</div>"
          );
        }

        return (
          '<div class="rb__filter" data-rb-filter="' + esc(f.key) + '">' +
            "<h3>" + esc(f.label) + "</h3>" +
            '<div class="rb__range">' +
              (f.key === "carat" ? '<input type="number" inputmode="decimal" step="0.01" min="0" placeholder="Min" aria-label="Minimum carat weight" data-rb-caratmin />' : '<input type="number" inputmode="numeric" min="0" placeholder="Min" aria-label="Minimum price in Malaysian ringgit" data-rb-pricemin />') +
              (f.key === "carat" ? '<input type="number" inputmode="decimal" step="0.01" min="0" placeholder="Max" aria-label="Maximum carat weight" data-rb-caratmax />' : '<input type="number" inputmode="numeric" min="0" placeholder="Max" aria-label="Maximum price in Malaysian ringgit" data-rb-pricemax />') +
            "</div>" +
          "</div>"
        );
      }).join("");
    }

    function renderGrid(list) {
      if (!gridRoot) return;

      var btnLabel;
      if (kind === "setting") btnLabel = "Select this setting";
      else if (kind === "gemstone") btnLabel = "Select this gemstone";
      else btnLabel = "Select this diamond";

      function selectButton(p, meta, img, productUrl, className) {
        return '<button type="button" class="' + className + '" ' + (meta.available ? '' : 'disabled ') +
          'data-rb-select data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" data-img="' + esc(img) + '" data-url="' + esc(productUrl) + '" data-variant-id="' + esc(meta.variant_id) + '" data-price-cents="' + esc(meta.price_cents) + '">' + esc(meta.available ? btnLabel : 'Unavailable') + '</button>';
      }
      function specMarkup(p) {
        var specs = diamondDisplaySpecs(p), missing = stepsRoot.dataset.notSpecified;
        return '<dl class="rb__diamond-specs"><div><dt>' + esc(stepsRoot.dataset.minimumCarat) + '</dt><dd>' + esc(specs.carat ? specs.carat + ' ct' : missing) + '</dd></div><div><dt>' + esc(stepsRoot.dataset.colour) + '</dt><dd>' + esc(specs.colour || missing) + '</dd></div><div><dt>' + esc(stepsRoot.dataset.clarity) + '</dt><dd>' + esc(specs.clarity || missing) + '</dd></div><div><dt>' + esc(stepsRoot.dataset.shape) + '</dt><dd>' + esc(specs.shape || missing) + '</dd></div></dl>';
      }
      if (kind === 'diamond' && state.view === 'table') {
        gridRoot.classList.add('rb__grid--table');
        gridRoot.innerHTML = '<div class="rb__diamond-table-wrap" role="region" aria-label="' + esc(stepsRoot.dataset.tableView) + '" tabindex="0"><table class="rb__diamond-table"><thead><tr><th scope="col">' + esc(stepsRoot.dataset.diamond) + '</th><th scope="col">' + esc(stepsRoot.dataset.minimumCarat) + '</th><th scope="col">' + esc(stepsRoot.dataset.colour) + '</th><th scope="col">' + esc(stepsRoot.dataset.clarity) + '</th><th scope="col">' + esc(stepsRoot.dataset.shape) + '</th><th scope="col">' + esc(stepsRoot.dataset.price) + '</th><th scope="col">' + esc(stepsRoot.dataset.actions) + '</th></tr></thead><tbody>' + list.map(function (p) {
          var img = p.images && p.images[0] && p.images[0].src ? p.images[0].src : '', meta = getFirstVariantMetaFromProductsJson(p), specs = diamondDisplaySpecs(p), productUrl = '/products/' + p.handle, missing = stepsRoot.dataset.notSpecified;
          return '<tr><th scope="row"><a href="' + esc(productUrl) + '" aria-label="' + esc(p.title) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') + '<span>' + esc(diamondCatalogueTitle(p)) + '</span></a></th><td><strong>' + esc(specs.carat ? specs.carat + ' ct' : missing) + '</strong></td><td>' + esc(specs.colour || missing) + '</td><td>' + esc(specs.clarity || missing) + '</td><td>' + esc(specs.shape || missing) + '</td><td class="rb__diamond-table-price">' + esc(meta.available ? fmtMoneyCents(meta.price_cents) : 'Currently unavailable') + '</td><td><button type="button" class="pj-assist-button" data-pj-compare="' + esc(p.handle) + '" aria-pressed="false">' + esc(stepsRoot.dataset.compare) + '</button>' + selectButton(p, meta, img, productUrl, 'rb__btn rb__btn--ghost') + '</td></tr>';
        }).join('') + '</tbody></table></div>';
        return;
      }
      gridRoot.classList.remove('rb__grid--table');
      gridRoot.innerHTML = list.map(function (p) {
        var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : "";
        var meta = getFirstVariantMetaFromProductsJson(p);
        var cents = meta.price_cents;
        var productUrl = "/products/" + p.handle;

        return (
          '<div class="rb__card">' +
            '<a class="rb__card-link" href="' + esc(productUrl) + '" aria-label="' + esc(p.title) + '" style="text-decoration:none; color:inherit;">' +
              '<div class="rb__card-media">' +
                (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async"/>' : "") +
              "</div>" +
              '<div class="rb__card-body" style="gap:8px;">' +
                '<div class="rb__card-title">' + esc(kind === 'diamond' ? diamondCatalogueTitle(p) : p.title) + "</div>" +
                '<div class="rb__card-price">' + esc(meta.available ? fmtMoneyCents(cents) : 'Currently unavailable') + "</div>" +
                (kind === 'diamond' ? specMarkup(p) : '') +
              "</div>" +
            "</a>" +
            '<div class="rb__card-body" style="padding-top:0;">' +
              '<button type="button" class="pj-assist-button" data-pj-compare="' + esc(p.handle) + '" aria-pressed="false">' + esc(stepsRoot.dataset.compare) + '</button>' +
              (kind === 'setting' ? '<a class="rb__btn rb__btn--ghost" href="' + esc(productUrl) + '">Choose metal &amp; details</a>' : selectButton(p, meta, img, productUrl, 'rb__btn rb__btn--ghost')) +
            "</div>" +
          "</div>"
        );
      }).join("");
    }

    function refresh() {
      if (!state.ready) return;
      var filtered = applyFilters(state.loaded, state, kind);
      if (kind === 'diamond') filtered = sortDiamonds(filtered, state.sort);
      state.filtered = filtered;

      var totalPages = Math.max(1, Math.ceil(filtered.length / state.perPage));
      state.currentPage = Math.min(state.currentPage, totalPages);
      var offset = (state.currentPage - 1) * state.perPage;
      var shown = filtered.slice(offset, offset + state.perPage);
      if (countRoot) countRoot.textContent = stepsRoot.dataset.pageMatches.replace('[first]', filtered.length ? offset + 1 : 0).replace('[last]', offset + shown.length).replace('[total]', filtered.length);
      renderGrid(shown);
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      pageSizeRoot.hidden = false;
      qsa('[data-rb-page-size]', pageSizeRoot).forEach(function (button) { button.setAttribute('aria-pressed', String(Number(button.dataset.rbPageSize) === state.perPage)); });
      function pageButton(page, label, disabled, current) {
        return '<button type="button" data-rb-page="' + page + '"' + (disabled ? ' disabled' : '') + (current ? ' aria-current="page"' : '') + ' aria-label="' + esc(label || stepsRoot.dataset.pageLabel.replace('[page]', page)) + '">' + esc(label || page) + '</button>';
      }
      var numbers = Array.from(new Set([1, totalPages, state.currentPage - 1, state.currentPage, state.currentPage + 1])).filter(function (page) { return page >= 1 && page <= totalPages; }).sort(function (a, b) { return a - b; });
      paginationRoot.innerHTML = pageButton(state.currentPage - 1, stepsRoot.dataset.previous, state.currentPage === 1) +
        '<div class="rb__page-numbers">' + numbers.map(function (page, index) {
          return (index && page - numbers[index - 1] > 1 ? '<span aria-hidden="true">…</span>' : '') + pageButton(page, '', false, page === state.currentPage);
        }).join('') + '</div>' + pageButton(state.currentPage + 1, stepsRoot.dataset.next, state.currentPage === totalPages);
      paginationRoot.hidden = !filtered.length;
      if (kind === 'diamond') {
        qsa('[data-rb-view]', diamondTools).forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.rbView === state.view)); });
      }

      if (filtersRoot) {
        qsa("[data-rb-chip]", filtersRoot).forEach(function (b) {
          var k = b.getAttribute("data-key");
          var v = b.getAttribute("data-val");
          var set = ensureChipSet(k);
          if (set.has(v)) b.classList.add("is-on");
          else b.classList.remove("is-on");
          b.setAttribute('aria-pressed', String(set.has(v)));
        });
      }
    }

    if (kind === 'diamond') {
      var sortControl = qs('[data-rb-sort]', diamondTools);
      if (sortControl) sortControl.addEventListener('change', function () {
        state.sort = sortControl.value;
        state.currentPage = 1;
        refresh();
        focusResults();
      });
      diamondTools.addEventListener('click', function (event) {
        var viewButton = event.target.closest('[data-rb-view]');
        if (!viewButton || !state.ready) return;
        state.view = viewButton.dataset.rbView;
        state.currentPage = 1;
        refresh();
        focusResults();
      });
    }

    async function loadCatalogue() {
      if (state.loading) return;
      state.loading = true;
      state.ready = false;
      var version = ++state.loadVersion;
      var sources = [collection];
      var batches = new Map(), pending = [];
      pageSizeRoot.hidden = true;
      paginationRoot.hidden = true;
      if (filtersRoot) filtersRoot.innerHTML = '';
      if (gridRoot) { gridRoot.innerHTML = ''; gridRoot.setAttribute('aria-busy', 'true'); }
      if (countRoot) { countRoot.setAttribute('role', 'status'); countRoot.textContent = stepsRoot.dataset.catalogueLoading; }
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      function append(data) { batches.set(data.page, data.products); }
      try {
        await Promise.all(sources.map(async function (handle) {
          var first = await fetchCollectionProducts(handle, 1);
          append(first);
          for (var page = 2; page <= first.pages; page++) pending.push({handle:handle,page:page});
        }));
        await Promise.all(Array.from({length:4}, async function () {
          while (pending.length && version === state.loadVersion) {
            var request = pending.shift();
            var data = await fetchCollectionProducts(request.handle, request.page);
            if (data.page !== request.page) throw new Error('Catalogue page did not match the request');
            append(data);
          }
        }));
        if (version !== state.loadVersion) return;
        var products = new Map();
        Array.from(batches.keys()).sort(function (a, b) { return a - b; }).forEach(function (page) { batches.get(page).forEach(function (p) { products.set(p.id || p.handle, p); }); });
        state.loaded = Array.from(products.values()).filter(function (p) { return getFirstVariantMetaFromProductsJson(p).available; });
        state.ready = true;
        state.currentPage = 1;
        renderFilters();
        refresh();
      } catch (error) {
        state.loadVersion++;
        if (countRoot) countRoot.textContent = stepsRoot.dataset.catalogueError;
        if (loadMoreBtn) { loadMoreBtn.hidden = false; loadMoreBtn.textContent = stepsRoot.dataset.retry; }
        console.error(error);
      } finally {
        state.loading = false;
        if (gridRoot) gridRoot.removeAttribute('aria-busy');
      }
    }

    // Tabs handler (diamond page only)
    if (stoneTabs && (kind === "diamond" || kind === "gemstone")) {
      syncTabActiveUI();
      stoneTabs.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-stone],[data-stone-type]");
        if (!btn) return;
        e.preventDefault();

        var mode = readStoneModeFromBtn(btn);

        var s = ensureSession();
        var startKey = encodeURIComponent(s.started_with || s.start_mode || "diamond");

        if (mode === "gemstone") {
          if (kind === 'gemstone') return;
          // Optional override from Liquid
          var link = btn.getAttribute("data-gemstone-link") || RB.pages.chooseGemstone;
          window.location.href = link + "?start=" + startKey + "&stone=" + (s.edit_stone || 0);
          return;
        }

        setStoneMode(mode);
        if (kind === 'gemstone') {
          window.location.href = RB.pages.chooseDiamond + '?start=' + startKey + '&stone=' + (s.edit_stone || 0);
          return;
        }
        state.chips = {};
        state.priceMinCents = state.priceMaxCents = state.caratMin = state.caratMax = null;
        state.currentPage = 1;
        if (state.ready) renderFilters();
        syncTabActiveUI();
        refresh();
      });
    }

    if (filtersRoot) {
      filtersRoot.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-rb-chip]");
        if (!btn) return;

        var k = btn.getAttribute("data-key");
        var v = btn.getAttribute("data-val");
        var set = ensureChipSet(k);

        if (set.has(v)) set.delete(v);
        else {
          if (k === "fancy_color") set.clear();
          set.add(v);
          // Colour grades and fancy colours describe two different diamond systems.
          // Keep them mutually exclusive so selecting Pink cannot conflict with grade D, for example.
          if (k === "fancy_color") ensureChipSet("color").clear();
          if (k === "color") ensureChipSet("fancy_color").clear();
        }

        state.currentPage = 1;
        refresh();
      });

      filtersRoot.addEventListener("input", function (e) {
        state.currentPage = 1;
        if (e.target && e.target.matches("[data-rb-pricemin]")) {
          var val = e.target.value ? Number(e.target.value) : null;
          state.priceMinCents = (val == null || !isFinite(val)) ? null : Math.round(val * 100);
          refresh();
        }
        if (e.target && e.target.matches("[data-rb-pricemax]")) {
          var val2 = e.target.value ? Number(e.target.value) : null;
          state.priceMaxCents = (val2 == null || !isFinite(val2)) ? null : Math.round(val2 * 100);
          refresh();
        }
        if (e.target && e.target.matches("[data-rb-caratmin]")) {
          var caratMin = e.target.value ? Number(e.target.value) : null;
          state.caratMin = (caratMin == null || !isFinite(caratMin)) ? null : Math.max(0, caratMin);
          refresh();
        }
        if (e.target && e.target.matches("[data-rb-caratmax]")) {
          var caratMax = e.target.value ? Number(e.target.value) : null;
          state.caratMax = (caratMax == null || !isFinite(caratMax)) ? null : Math.max(0, caratMax);
          refresh();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        Object.keys(state.chips).forEach(function (k) { state.chips[k].clear(); });
        state.priceMinCents = null;
        state.priceMaxCents = null;
        state.caratMin = null;
        state.caratMax = null;

        if (filtersRoot) {
          var minInput = qs("[data-rb-pricemin]", filtersRoot);
          var maxInput = qs("[data-rb-pricemax]", filtersRoot);
          var caratMinInput = qs("[data-rb-caratmin]", filtersRoot);
          var caratMaxInput = qs("[data-rb-caratmax]", filtersRoot);
          if (minInput) minInput.value = "";
          if (maxInput) maxInput.value = "";
          if (caratMinInput) caratMinInput.value = "";
          if (caratMaxInput) caratMaxInput.value = "";
        }

        state.currentPage = 1;
        refresh();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", async function () {
        if (!state.ready) { await loadCatalogue(); return; }
      });
    }

    function focusResults() {
      if (!countRoot) return;
      countRoot.tabIndex = -1;
      countRoot.focus({preventScroll:true});
      countRoot.scrollIntoView({block:'start', behavior:'auto'});
    }
    paginationRoot.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rb-page]');
      if (!button || button.disabled || !state.ready) return;
      state.currentPage = Number(button.dataset.rbPage);
      refresh();
      focusResults();
    });
    pageSizeRoot.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rb-page-size]');
      if (!button || !state.ready) return;
      state.perPage = Number(button.dataset.rbPageSize);
      state.currentPage = 1;
      refresh();
    });

    if (gridRoot) {
      gridRoot.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-rb-select]");
        if (!btn) return;

        var handle = btn.getAttribute("data-handle");
        var title = btn.getAttribute("data-title");
        var img = btn.getAttribute("data-img");
        var url = btn.getAttribute("data-url");
        var variantId = btn.getAttribute("data-variant-id");
        var priceCents = btn.getAttribute("data-price-cents");

        var s = ensureSession();

        if (!s.started_with && !s.start_mode) setStartedWith(s, "diamond");
        s = ensureSession();

        var startKey = encodeURIComponent(s.started_with || s.start_mode || "diamond");

        var payload = {
          handle: handle,
          title: title || null,
          image: img || null,
          product_url: url || ("/products/" + handle),
          variant_id: variantId ? Number(variantId) : null,
          price_cents: safeNum(priceCents),
          stone_kind: (kind === "gemstone") ? "gemstone" : (kind === "diamond" ? "diamond" : null)
        };

        var selectedProduct = state.loaded.find(function (product) { return product.handle === handle; });
        if (kind === 'diamond' || kind === 'gemstone') payload.specs = stoneSpecs(selectedProduct || { title: title, tags: [] });

        // Stone selection (diamond or gemstone) always saves into s.diamond
        if (kind === "diamond" || kind === "gemstone") {
          saveStone(s, payload);

          if (s.setting && s.setting.handle) {
            window.location.href = nextBuilderPage(s);
            return;
          }

          window.location.href = RB.pages.chooseSetting + "?start=" + startKey;
          return;
        }

        // Setting selection
        var selectedSetting = selectedProduct;
        payload.stone_count = stoneCount(selectedSetting);
        s.setting = payload;
        s.stones = chosenStones(s);
        writeSession(s);
        window.location.href = nextBuilderPage(s);
      });
    }

    await loadCatalogue();

    // Re-render steps after load so step bar reflects latest session values
    var s2 = ensureSession();
    renderSteps(stepsRoot, s2, pageKey);
  }

  // ----------------- COMPLETE PAGE -----------------
  async function initCompletePage(rbRoot) {
    clearInlineSummaryIfExists();

    var session = ensureSession();

    var start = getParam("start");
    if (start === "diamond" || start === "setting") {
      setStartedWith(session, start);
      session = ensureSession();
    }
    if (!session.started_with && !session.start_mode) setStartedWith(session, "diamond");
    session = ensureSession();

    var stepsRoot = qs("[data-rb-steps]", rbRoot);
    renderSteps(stepsRoot, session, "complete");

    var left = qs("[data-rb-complete-left]", rbRoot);
    var right = qs("[data-rb-complete-right]", rbRoot);

    if (!session.diamond || !session.diamond.handle || !session.setting || !session.setting.handle) {
      var builderHref = (session.started_with === "setting")
        ? (RB.pages.chooseSetting + "?start=setting")
        : (RB.pages.chooseDiamond + "?start=diamond");

      if (left) left.innerHTML = '<p class="rb__danger">Missing stone or setting. Please choose both first.</p>';
      if (right) right.innerHTML = '<a class="rb__btn rb__btn--ghost" href="' + esc(builderHref) + '">Go to builder</a>';
      return;
    }

    var stone = null;
    var setting = null;

    try {
      var products = await Promise.all([fetchProductByHandle(session.diamond.handle), fetchProductByHandle(session.setting.handle)]);
      stone = products[0];
      setting = products[1];
    } catch (e) {
      console.error(e);
    }

    if (!stone || !setting) {
      if (left) left.innerHTML = '<p class="rb__danger">Could not load product data. Please refresh and try again.</p>';
      return;
    }

    session.setting.stone_count = stoneCount(setting);
    session.stones = chosenStones(session);
    writeSession(session);
    var requiredPage = nextBuilderPage(session);
    if (requiredPage.indexOf(RB.pages.complete) !== 0) {
      window.location.replace(requiredPage);
      return;
    }
    var selectedStones = chosenStones(session);
    var stoneProducts;
    try {
      stoneProducts = await Promise.all(selectedStones.map(function (selected) { return fetchProductByHandle(selected.handle); }));
    } catch (error) {
      if (left) left.innerHTML = '<p class="rb__danger">Could not load all selected stones. Please refresh to try again.</p>';
      return;
    }
    var stoneVariants = stoneProducts.map(function (product, index) {
      return findVariantById(product, selectedStones[index].variant_id);
    });
    function allStonesAvailable() {
      return stoneVariants.length === stoneCount(session.setting) && stoneVariants.every(function (variant) { return variant && variant.available; });
    }

    // Stone variant: if we stored a variant id, use it
    var stoneVariant = null;
    if (session.diamond && session.diamond.variant_id) {
      stoneVariant = findVariantById(stone, session.diamond.variant_id) || null;
    }
    if (!session.diamond.variant_id) stoneVariant = (stone.variants || [])[0] || null;

    // Setting variant: if we stored a variant id, use it
    var settingVariant = null;
    if (session.setting && session.setting.variant_id) {
      settingVariant = findVariantById(setting, session.setting.variant_id) || null;
    }
    if (!session.setting.variant_id) settingVariant = (setting.variants || [])[0] || null;

    function renderSummaryCard(title, img, priceCents, label, linkUrl, details, changeUrl) {
      return (
        '<div class="rb__summary">' +
          (img ? '<a href="' + esc(linkUrl) + '"><img src="' + esc(img) + '" alt="' + esc(title) + '" width="160" height="160"/></a>' : "") +
          '<div class="rb__summary-content">' +
            '<p class="rb__summary-kicker">' + esc(label) + "</p>" +
            '<h2 class="rb__summary-heading">' + esc(title) + "</h2>" +
            (details && details.length ? '<div class="rb__summary-specs">' + details.filter(Boolean).map(function (detail) { return '<span>' + esc(detail) + '</span>'; }).join('') + '</div>' : '') +
            '<p class="rb__summary-price">' + esc(priceCents == null ? 'Unavailable' : fmtMoneyCents(priceCents)) + "</p>" +
            '<a class="rb__change" href="' + esc(changeUrl) + '">Change ' + esc(label === 'Selected Setting' ? 'setting' : label.toLowerCase()) + '</a>' +
          "</div>" +
        "</div>"
      );
    }

    var stoneTitle = (session.diamond && session.diamond.title) ? session.diamond.title : stone.title;
    var settingTitle = (session.setting && session.setting.title) ? session.setting.title : setting.title;

    function renderCurrentSummary() {
      var startKey = encodeURIComponent(session.started_with || 'diamond');
      var stoneChange = (session.diamond.stone_kind === 'gemstone' ? RB.pages.chooseGemstone : RB.pages.chooseDiamond) + '?start=' + startKey;
      if (left) left.innerHTML =
        stoneProducts.map(function (product, index) {
          var variant = stoneVariants[index];
          var changePage = selectedStones[index].stone_kind === 'gemstone' ? RB.pages.chooseGemstone : RB.pages.chooseDiamond;
          var specs = selectedStones[index].specs || stoneSpecs(product);
          var details = [];
          if (specs.carat) details.push(specs.carat + ' ct');
          if (specs.clarity) details.push(specs.clarity + ' clarity');
          if (specs.shape) details.push(specs.shape + ' shape');
          return renderSummaryCard(product.title, imgForVariant(product, variant), variant ? priceCentsFromProductJsVariant(variant) : null, stoneLabel(index, selectedStones.length), '/products/' + product.handle, details, changePage + '?start=' + startKey + '&stone=' + index);
        }).join("") +
        renderSummaryCard(settingTitle, imgForVariant(setting, settingVariant), settingVariant ? priceCentsFromProductJsVariant(settingVariant) : null, 'Selected Setting', '/products/' + setting.handle, [session.setting.metal || session.setting.variant_title, session.setting.ring_size ? 'US size ' + session.setting.ring_size : null], RB.pages.chooseSetting + '?start=' + startKey);
    }

    // Build option selects from variants so it supports Metal now and Size later
    function getOptionCountFromVariants(p) {
      if (!p || !p.variants || !p.variants[0]) return 0;
      var v = p.variants[0];
      var c = 0;
      if (v.option1) c += 1;
      if (v.option2) c += 1;
      if (v.option3) c += 1;
      return c;
    }

    function getOptionName(p, idx) {
      if (!p || !p.options || !p.options[idx]) return "Option " + (idx + 1);
      var o = p.options[idx];
      if (typeof o === "string") return o;
      if (o && o.name) return o.name;
      return "Option " + (idx + 1);
    }

    function getOptionValuesFromVariants(p, idx) {
      var key = "option" + (idx + 1);
      var set = {};
      (p.variants || []).forEach(function (v) {
        var val = v[key];
        if (val) set[val] = true;
      });
      return Object.keys(set);
    }

    var optionCount = Array.isArray(setting.options) ? setting.options.length : getOptionCountFromVariants(setting);
    var preset = settingVariant || null;

    var optionHtml = "";
    for (var i = 0; i < optionCount; i++) {
      var name = getOptionName(setting, i);
      var values = getOptionValuesFromVariants(setting, i);
      var presetVal = preset ? preset["option" + (i + 1)] : null;

      optionHtml +=
        '<div class="rb__formrow">' +
          '<label for="rb-setting-option-' + i + '">' + esc(name) + '</label>' +
          '<select id="rb-setting-option-' + i + '" data-rb-setting-opt data-index="' + i + '">' +
            (presetVal ? '' : '<option value="" selected disabled>Choose ' + esc(name) + '</option>') +
            values.map(function (val) {
              var selected = (presetVal && val === presetVal) ? ' selected="selected"' : "";
              return '<option value="' + esc(val) + '"' + selected + ">" + esc(val) + "</option>";
            }).join("") +
          "</select>" +
        "</div>";
    }

    var ringSizes = ['3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13'];
    var sizeHtml =
      '<div class="rb__formrow">' +
        '<label for="rb-ring-size">US ring size</label>' +
        '<select id="rb-ring-size" data-rb-ring-size-complete required>' +
          '<option value="">Select a US ring size</option>' +
          ringSizes.map(function (size) {
            return '<option value="' + size + '"' + (String(session.setting.ring_size || '') === size ? ' selected="selected"' : '') + '>US ' + size + '</option>';
          }).join('') +
        '</select>' +
        '<p class="rb__field-help">Half sizes are available from US 3 to US 13.</p>' +
      '</div>';

    if (right) {
      right.innerHTML =
        '<h2 style="margin:0 0 8px;">Complete Ring</h2>' +
        '<p style="margin:0 0 10px; opacity:.75;">Confirm your setting options, then add the completed ring to cart.</p>' +
        optionHtml +
        sizeHtml +
        '<p class="rb__preview-note">Your setting and selected stones are shown separately. Setting images illustrate the design.</p>' +
        '<div class="rb__total" aria-live="polite"><span>Total</span><span data-rb-total></span></div>' +
        '<p class="rb__danger" role="status" data-rb-cart-status></p>' +
        '<div style="margin-top:14px;"><button type="button" class="rb__btn" data-rb-add>Add completed ring to cart</button></div>';
    }

    function findSettingVariantByOptions() {
      if (!right) return settingVariant;
      var selects = qsa("[data-rb-setting-opt]", right);
      var chosen = selects.map(function (s) { return s.value; });

      var match = (setting.variants || []).find(function (v) {
        for (var i2 = 0; i2 < chosen.length; i2++) {
          var key2 = "option" + (i2 + 1);
          if ((v[key2] || "") !== chosen[i2]) return false;
        }
        return true;
      });

      return match || null;
    }

    function refreshTotal() {
      settingVariant = findSettingVariantByOptions();

      var stoneCents = stoneVariants.reduce(function (sum, variant) { return sum + priceCentsFromProductJsVariant(variant); }, 0);
      var settingCents = priceCentsFromProductJsVariant(settingVariant);

      var total = stoneCents + settingCents;
      var totalEl = right ? qs("[data-rb-total]", right) : null;
      var sizeInput = right ? qs('[data-rb-ring-size-complete]', right) : null;
      var sizeChosen = !!(sizeInput && sizeInput.value);
      var available = !!(allStonesAvailable() && settingVariant && settingVariant.available && sizeChosen);
      if (totalEl) totalEl.textContent = available ? fmtMoneyCents(total) : 'Unavailable';
      var add = qs('[data-rb-add]', right);
      if (add) add.disabled = !available;
      var status = qs('[data-rb-cart-status]', right);
      if (status) status.textContent = available ? '' : (!sizeChosen ? 'Please select a US ring size.' : 'This combination is unavailable. Please change your setting options or selected stone.');
      if (settingVariant) {
        var options = variantOptions(setting, settingVariant);
        session.setting.variant_id = settingVariant.id;
        session.setting.price_cents = settingCents;
        session.setting.image = imgForVariant(setting, settingVariant);
        session.setting.variant_title = settingVariant.title;
        session.setting.variant_options = options;
        session.setting.metal = metalFromOptions(options, settingVariant.title);
      }
      session.setting.ring_size = sizeInput ? sizeInput.value : null;
      stoneVariants.forEach(function (variant, index) {
        if (variant) session.stones[index].price_cents = priceCentsFromProductJsVariant(variant);
      });
      session.diamond = session.stones[0];
      writeSession(session);
      renderCurrentSummary();
      renderSteps(stepsRoot, session, 'complete');
    }

    if (right) {
      right.addEventListener("change", function (e) {
        if (e.target && e.target.matches("[data-rb-setting-opt], [data-rb-ring-size-complete]")) refreshTotal();
      });
    }

    refreshTotal();

    if (right) {
      var addBtn = qs("[data-rb-add]", right);
      if (addBtn) {
        addBtn.addEventListener("click", async function () {
          settingVariant = findSettingVariantByOptions();
          var sizeInput = qs('[data-rb-ring-size-complete]', right);
          if (!allStonesAvailable() || !settingVariant || !settingVariant.available || !sizeInput || !sizeInput.value) {
            refreshTotal();
            return;
          }

          // Persist chosen setting variant back to session (so step bar stays consistent)
          var s2 = ensureSession();
          if (s2.setting) {
            s2.setting.variant_id = Number(settingVariant.id);
            s2.setting.price_cents = priceCentsFromProductJsVariant(settingVariant);
            s2.setting.ring_size = sizeInput.value;
            writeSession(s2);
          }

          addBtn.disabled = true;
          addBtn.setAttribute('aria-busy', 'true');
          await finalizeToCart(session, stoneVariants.map(function (variant) { return variant.id; }), settingVariant.id, setting.handle);
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-busy');
        });
      }
    }

    // Re-render steps at the end so step bar reflects latest prices
    var s3 = ensureSession();
    renderSteps(stepsRoot, s3, "complete");
  }

  function initBuildLibrary(root) {
    var key = 'PJ_SAVED_BUILDS_V1';
    function saved() { try { var a = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(a) ? a.slice(0, 12) : []; } catch (_) { return []; } }
    function compact(s) {
      function item(x) { return x && x.handle && x.variant_id ? {h:x.handle,v:String(x.variant_id),k:x.stone_kind || 'diamond'} : null; }
      return {v:1,start:s.started_with === 'setting' ? 'setting' : 'diamond',mode:s.stone_mode === 'mined' ? 'mined' : 'lab',setting:item(s.setting),size:s.setting && s.setting.ring_size || '',stones:chosenStones(s).map(item)};
    }
    function validate(d) {
      if (!d || d.v !== 1 || !['setting','diamond'].includes(d.start) || !['lab','mined'].includes(d.mode) || !Array.isArray(d.stones) || d.stones.length > 3) throw Error('This build link is not valid.');
      if (d.size && !/^(?:[3-9](?:\.5)?|1[0-2](?:\.5)?|13)$/.test(String(d.size))) throw Error('The ring size in this build is not supported.');
      [d.setting].concat(d.stones).filter(Boolean).forEach(function(x){if(!/^[a-z0-9][a-z0-9-]{0,200}$/.test(x.h)||!/^\d{1,18}$/.test(String(x.v))||!['diamond','gemstone'].includes(x.k))throw Error('This build contains an invalid selection.');});
      if(!d.setting&&!d.stones.some(Boolean))throw Error('Choose a setting or stone before saving or sharing.');
      return d;
    }
    function encode(d) { return btoa(JSON.stringify(validate(d))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); }
    function decode(s) { try { if(s.length>5000||!/^[A-Za-z0-9_-]+$/.test(s))throw Error();return validate(JSON.parse(atob(s.replace(/-/g,'+').replace(/_/g,'/')))); } catch(_) {throw Error('This build link is invalid or incomplete. Please request a new share link.');} }
    function snapshot(name, data) {
      var list=saved();list.unshift({id:Date.now().toString(36)+Math.random().toString(36).slice(2,6),name:String(name).slice(0,70),date:new Date().toISOString(),data:data});
      localStorage.setItem(key,JSON.stringify(list.slice(0,12)));
    }
    async function restore(data) {
      validate(data);
      async function load(x,setting) {
        if(!x)return null;
        var p=await fetchProductByHandle(x.h),v=findVariantById(p,x.v),type=String(p.type||p.product_type||'').toLowerCase(),tags=(p.tags||[]).map(function(t){return String(t).toLowerCase();});
        if(!v)throw Error('An option in this build is no longer listed. Your current build has been kept.');
        if(setting ? !(type==='ring setting'||tags.includes('ring setting')||tags.includes('setting')) : !(/diamond|gemstone/.test(type)&&!/ring|earring|necklace|bracelet/.test(type)))throw Error('A product in this link cannot be used in that builder step.');
        var options=variantOptions(p,v);
        return {handle:p.handle,title:p.title,product_url:'/products/'+p.handle,variant_id:v.id,variant_title:v.title,variant_options:options,price_cents:priceCentsFromProductJsVariant(v),image:imgForVariant(p,v),metal:setting?metalFromOptions(options,v.title):null,stone_count:setting?stoneCount(p):null,ring_size:setting?String(data.size||''):null,stone_kind:/gemstone/.test(type)?'gemstone':'diamond',specs:stoneSpecs(p)};
      }
      status.textContent='Checking the latest products and prices…';
      var loaded=await Promise.all([load(data.setting,true),Promise.all(data.stones.map(function(x){return load(x,false);}))]);
      var s={pair_id:makePairId(),started_at:Date.now(),started_with:data.start,start_mode:data.start,stone_mode:data.mode,setting:loaded[0],stones:loaded[1],diamond:loaded[1][0]||null};
      writeSession(s);window.location.assign(nextBuilderPage(s));
    }
    var box=document.createElement('div');box.className='rb__library';
    box.innerHTML='<div class="rb__library-actions"><button type="button" class="rb__btn rb__btn--ghost" data-build-save>Save build</button><button type="button" class="rb__btn rb__btn--ghost" data-build-share>Share build</button><details data-build-library><summary>Saved builds <span data-build-count></span></summary><p>Up to 12 builds are saved in this browser. Use a share link to open a build on another device. Prices and availability are checked when you reopen it.</p><div data-build-list></div></details></div><form data-build-name hidden><label>Name this build <input maxlength="70" name="build-name" value="My ring" required></label><button class="rb__btn" type="submit">Save</button></form><div data-build-link hidden><label>Share link <input readonly aria-label="Shareable ring build link"></label><button class="rb__btn rb__btn--ghost" type="button" data-build-copy>Copy link</button><p>Anyone with this link can view the selected products and ring size.</p></div><p role="status" data-build-status></p>';
    var steps=qs('[data-rb-steps]',root);if(!steps)return;steps.insertAdjacentElement('afterend',box);
    var reset=document.createElement('button');reset.type='button';reset.className='rb__btn rb__btn--ghost';reset.dataset.buildReset='';reset.textContent=steps.dataset.startOver;
    qs('[data-build-share]',box).insertAdjacentElement('afterend',reset);
    var retention=document.createElement('p');retention.textContent=steps.dataset.savingShort;box.prepend(retention);
    var savingHelp=document.createElement('details');savingHelp.className='pj-saving-help';savingHelp.innerHTML='<summary>'+esc(steps.dataset.savingHelp)+'</summary><p>'+esc(steps.dataset.sessionNote)+'</p>';retention.after(savingHelp);
    var ask=document.createElement('button');ask.type='button';ask.className='rb__btn rb__btn--ghost';ask.textContent=steps.dataset.askBuild;ask.dataset.buildAsk='';reset.after(ask);
    ask.onclick=function(){attempt(function(){var s=ensureSession();var link=location.origin+RB.pages.complete+'#build='+encode(compact(s));var lines=[steps.dataset.enquiryIntro];if(s.setting){lines.push(s.setting.title,s.setting.metal||s.setting.variant_title||'',s.setting.ring_size?'US ring size: '+s.setting.ring_size:'');}chosenStones(s).filter(Boolean).forEach(function(stone){lines.push(stone.title);});lines.push(link);if(window.PJShopping)window.PJShopping.ask(lines.filter(Boolean).join('\n'),ask);});};
    var help=document.createElement('a');help.className='pj-guide-link';var isSetting=location.pathname===RB.pages.chooseSetting;help.href=isSetting?'/blogs/journal/14k-vs-18k-gold':'/blogs/journal/are-lab-grown-diamonds-real-diamonds';help.textContent=isSetting?steps.dataset.goldGuide:steps.dataset.diamondGuide;if(location.pathname!==RB.pages.chooseGemstone)box.append(help);
    reset.onclick=function(){clearSession();window.location.assign(RB.pages.chooseSetting+'?start=setting');};
    var status=qs('[data-build-status]',box),form=qs('[data-build-name]',box),linkBox=qs('[data-build-link]',box),listRoot=qs('[data-build-list]',box);
    function render(){var rows=saved();qs('[data-build-count]',box).textContent='('+rows.length+')';listRoot.innerHTML=rows.length?rows.map(function(row){return '<div class="rb__saved-row"><span>'+esc(row.name)+'<small>'+esc(new Date(row.date).toLocaleDateString())+'</small></span><button type="button" data-build-open="'+esc(row.id)+'">Open</button><button type="button" data-build-remove="'+esc(row.id)+'" aria-label="Delete '+esc(row.name)+'">Delete</button></div>';}).join(''):'<p>No saved builds yet.</p>';}
    async function attempt(fn){try{await fn();}catch(e){status.textContent=e.message||'Unable to save this build in your browser.';}}
    qs('[data-build-save]',box).onclick=function(){attempt(function(){validate(compact(ensureSession()));form.hidden=false;qs('input',form).focus();});};
    form.onsubmit=function(e){e.preventDefault();attempt(function(){snapshot(qs('input',form).value.trim()||'My ring',validate(compact(ensureSession())));form.hidden=true;status.textContent='Build saved in this browser.';render();});};
    qs('[data-build-share]',box).onclick=function(){attempt(async function(){var url=location.origin+RB.pages.complete+'#build='+encode(compact(ensureSession()));linkBox.hidden=false;qs('input',linkBox).value=url;status.textContent='Your share link is ready.';if(navigator.share){try{await navigator.share({title:'My Purnama ring build',url:url});}catch(e){if(e.name!=='AbortError')status.textContent='Copy the link below to share your build.';}}});};
    qs('[data-build-copy]',box).onclick=function(){attempt(async function(){var input=qs('input',linkBox);input.select();try{await navigator.clipboard.writeText(input.value);status.textContent='Link copied.';}catch(_){status.textContent='Select and copy the link above.';}});};
    listRoot.onclick=function(e){var open=e.target.closest('[data-build-open]'),remove=e.target.closest('[data-build-remove]');if(remove)attempt(function(){localStorage.setItem(key,JSON.stringify(saved().filter(function(r){return r.id!==remove.dataset.buildRemove;})));render();});if(open)attempt(async function(){var row=saved().find(function(r){return r.id===open.dataset.buildOpen;});if(row){open.disabled=true;try{await restore(row.data);}finally{open.disabled=false;}}});};
    render();
    if(location.hash.startsWith('#build='))attempt(function(){var data=decode(location.hash.slice(7)),invite=document.createElement('div');invite.className='rb__shared-invite';invite.innerHTML='<strong>A ring build has been shared with you</strong><p>'+esc(steps.dataset.sharedNote)+'</p><button type="button" class="rb__btn">Open shared build</button> <button type="button" class="rb__btn rb__btn--ghost">Keep my current build</button>';box.prepend(invite);var buttons=invite.querySelectorAll('button');buttons[0].onclick=function(){attempt(async function(){buttons[0].disabled=true;try{await restore(data);}finally{buttons[0].disabled=false;}});};buttons[1].onclick=function(){window.location.assign(nextBuilderPage(ensureSession()));};});
  }

  // ----------------- BOOT (BUILDER PAGES ONLY) -----------------
  document.addEventListener("DOMContentLoaded", function () {
    var rbRoot = qs(".rb");
    if (!rbRoot) return;

    clearInlineSummaryIfExists();

    var s = ensureSession();

    initBuildLibrary(rbRoot);
    if (location.hash.startsWith('#build=')) {
      renderSteps(qs('[data-rb-steps]', rbRoot), s, 'complete');
      return;
    }

    var start = getParam("start");
    if (start === "diamond" || start === "setting") {
      setStartedWith(s, start);
      s = ensureSession();
    }

    var page = rbRoot.getAttribute("data-rb-page"); // "choose" or "complete"
    if (page === "choose") initChoosePage(rbRoot);
    if (page === "complete") initCompletePage(rbRoot);
  });
})();
